import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["currentPage", "totalPages", "onPrev", "onNext", "dark", "className", "htmlProps"];
import { forwardRef } from 'react';
import cn from 'classnames';
import ArrowButton from "./ArrowButton";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Banner = function Banner(_ref, ref) {
  var _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    _ref$totalPages = _ref.totalPages,
    totalPages = _ref$totalPages === void 0 ? 1 : _ref$totalPages,
    onPrev = _ref.onPrev,
    onNext = _ref.onNext,
    dark = _ref.dark,
    className = _ref.className,
    htmlProps = _ref.htmlProps,
    bannerPaginationProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: cn('flex flex-col items-center', className)
  }, bannerPaginationProps), htmlProps), {}, {
    children: [/*#__PURE__*/_jsxs("p", {
      className: "flex items-center justify-center mb-16 text-center text-white font-gil text-16 leading-20 tracking-4",
      children: [/*#__PURE__*/_jsx("span", {
        className: "mr-4 font-bold",
        children: "".concat(currentPage.toString().length < 2 ? 0 : '').concat(currentPage)
      }), "/ ".concat(totalPages.toString().length < 2 ? 0 : '').concat(totalPages)]
    }), /*#__PURE__*/_jsx(ArrowButton, {
      direction: "left",
      disabled: currentPage <= 1,
      onClick: onPrev,
      dark: dark
    }), /*#__PURE__*/_jsx(ArrowButton, {
      direction: "right",
      disabled: currentPage >= totalPages,
      onClick: onNext,
      dark: dark
    })]
  }));
};
export default /*#__PURE__*/forwardRef(Banner);